import styled, { css } from 'styled-components';

import { CONTAINER_PADDING_X } from '@/components/molecule/ChatInput/ChatInput.styles';
import { DOWNWARD_PANEL_QUERY, QUESTION_PANEL_GAP } from '@/utils/constants';

// INFO: On an Unstarted Thread the open Question Panel's layer flips to below the Chat Composer, into the
// room ChatWindowWrapper leaves beneath it. Because that room is inside the wrapper's overflow box, the
// downward panel is not clipped.
//
// Gated on DOWNWARD_PANEL_QUERY, which is deliberately *wider* than the CENTRED_LAYOUT_QUERY that gates
// the centring — so between the two gates the block is top-aligned while the panel still opens downward.
// The gates disagreeing is the intent, and it fails safe in that order: a centred block with too little
// room clips the Greeting, which has nowhere to go, whereas a top-aligned one clips only the panel, which
// already scrolls internally.
const belowComposer = css`
  @media ${DOWNWARD_PANEL_QUERY} {
    bottom: auto;
    top: calc(100% + ${QUESTION_PANEL_GAP});
    max-height: none;
  }
`;

export const ComposerPanelLayer = styled.div<{ $isBelowComposer: boolean }>`
  position: absolute;
  bottom: calc(100% + ${QUESTION_PANEL_GAP});
  left: ${CONTAINER_PADDING_X};
  right: ${CONTAINER_PADDING_X};
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
  /* INFO: Enough clearance so the panel does not overlap follow-up chips or the
     feedback nudge that render above the InputContainer in the document flow. */
  max-height: min(58vh, calc(100dvh - 280px));

  ${({ $isBelowComposer }) => $isBelowComposer && belowComposer}
`;
